import React from 'react';

// Placeholder v37.0. El catalogo real de consultas (Q1 Proyectos x Cliente,
// Q2 aging, Q3 CxP x proyecto) llega en v37.1.
function Consultas() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100%', minHeight: '60vh',
      fontFamily: 'Segoe UI, sans-serif', color: '#545454', gap: 10,
      padding: 40, textAlign: 'center'
    }}>
      <i className="ti ti-chart-bar" style={{ fontSize: 48, color: '#87B749' }} aria-hidden="true" />
      <h2 style={{ margin: 0, fontSize: 20, fontWeight: 500, color: '#012E40' }}>
        Consultas y reportes
      </h2>
      <p style={{ margin: 0, fontSize: 14, color: '#777' }}>
        Proximamente v37.1
      </p>
    </div>
  );
}

export default Consultas;
